import { COLORS } from './../utility/tasks/colors';
import { styled, alpha } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import { isBGClrDark } from '../utility/UtilityFunctions';
// To Fetch Current theme of Office
export const THEME_ID = {
	COLORFUL: '#000000',
	DARK_GREY: '#000001',
	BLACK: '#000002',
	WHITE: '#000003',
};

export const CURRENT_OFFICE_THEME = {
	bodyBackgroundColor: '#ffffff', // '#ffffff', '#262626'
	bodyForegroundColor: '#444444', // '#444444', '#C6C1C1'
	controlBackgroundColor: '#fdfdfd', //'#fdfdfd', '#363636'
	controlForegroundColor: '#444444', //'#444444', '#f0f0f0'
	themeId: THEME_ID.WHITE,
};

export const gapToken = {
	none: 0,
	small: 5,
	large: 10,
};

export const baseFontFamilyStyle =
	"'Segoe UI', Calibri, system-ui, -apple-system, BlinkMacSystemFont, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif";

export const handleTextTheme = themeId => {
	switch (themeId) {
		case THEME_ID.COLORFUL:
		case THEME_ID.WHITE:
			return 'ms_Label_light';
		default:
			return 'ms_Label_dark';
	}
};

export const switchMuiStyle = currentOfficeTheme => {
	return {
		'& .MuiFormControlLabel-label': {
			fontSize: '15px',
			fontFamily: baseFontFamilyStyle,
			color: currentOfficeTheme.bodyForegroundColor,
		},
	};
};

// Styling according to current theme of Office

export const dataGridsx = currentOfficeTheme => {
	return {
		filterPanel: {
			// Force usage of "And" operator

			// Display columns by ascending alphabetical order

			columnsSort: 'asc',
			filterFormProps: {
				// Customize inputs by passing props

				columnInputProps: {
					size: 'small',

					sx: {
						mt: 'auto',
					},
				},

				operatorInputProps: {
					size: 'small',

					sx: { mt: 'auto', color: currentOfficeTheme.bodyForegroundColor },
				},
			},

			sx: {
				// Customize inputs using css selectors
				boxShadow:
					currentOfficeTheme.themeId === THEME_ID.BLACK || currentOfficeTheme.themeId === THEME_ID.DARK_GREY
						? `${COLORS.BG_GREY_DARK} 0px 0px 1px 0.1px, ${COLORS.BG_GREY_DARK} 0px 0px 1px 0.1px, ${COLORS.BG_GREY_DARK} 0px 0px 1px 0.1px, ${COLORS.BG_GREY_DARK} 0px 0px 5px 0.1px`
						: '',

				'& .MuiDataGrid-filterForm': {
					p: 2,
					backgroundColor: currentOfficeTheme.bodyBackgroundColor,
					color: currentOfficeTheme.bodyForegroundColor,
					borderLeft: '1px solid #58b8fe',
				},

				'& .MuiDataGrid-filterForm:nth-child(even)': {
					backgroundColor: theme => (theme.palette.mode === 'dark' ? 'red' : 'yellow'),
				},

				'& .MuiDataGrid-filterFormLogicOperatorInput': {
					mr: 2,
					color: currentOfficeTheme.bodyForegroundColor,
				},

				'& .MuiDataGrid-filterFormColumnInput': {
					mr: 2,
					width: 150,
					color: currentOfficeTheme.bodyForegroundColor,
					backgroundColor: currentOfficeTheme.bodyBackgroundColor,
				},

				'& .MuiDataGrid-filterFormOperatorInput': {
					mr: 2,
					color: currentOfficeTheme.bodyForegroundColor,
					backgroundColor: currentOfficeTheme.bodyBackgroundColor,
				},

				'& .MuiDataGrid-filterFormValueInput': {
					width: 200,
					color: currentOfficeTheme.bodyForegroundColor,
				},

				'& .MuiSvgIcon-root': { color: currentOfficeTheme.bodyForegroundColor },
				'& .MuiFormLabel-root': { color: currentOfficeTheme.bodyForegroundColor },
				'& .MuiInputBase-root': {
					color: currentOfficeTheme.bodyForegroundColor,
					'& :hover': {
						color: currentOfficeTheme.bodyForegroundColor,
						backgroundColor: currentOfficeTheme.bodyBackgroundColor,
					},
					'&::before': {
						color: currentOfficeTheme.bodyForegroundColor,
						borderColor: COLORS.OUTLOOK_BLUE,
						outlineColor: COLORS.OUTLOOK_BLUE,
					},
				},
				'& .MuiNativeSelect-select': {
					backgroundColor: currentOfficeTheme.bodyBackgroundColor,
					'& option': {
						backgroundColor: currentOfficeTheme.bodyBackgroundColor,
						color: COLORS.BG_GREY_DARK,
					},
				},
			},
		},
		columnMenu: {
			sx: {
				'& .MuiSvgIcon-root': { color: currentOfficeTheme.bodyForegroundColor },
			},
		},
		columnsPanel: {
			sx: {
				boxShadow:
					currentOfficeTheme.themeId === THEME_ID.BLACK || currentOfficeTheme.themeId === THEME_ID.DARK_GREY
						? `${COLORS.BG_GREY_DARK} 0px 0px 1px 0.1px, ${COLORS.BG_GREY_DARK} 0px 0px 1px 0.1px, ${COLORS.BG_GREY_DARK} 0px 0px 1px 0.1px, ${COLORS.BG_GREY_DARK} 0px 0px 5px 0.1px`
						: '',
				backgroundColor: currentOfficeTheme.bodyBackgroundColor,
				color: currentOfficeTheme.bodyForegroundColor,
				'& .MuiDataGrid-panelHeader': {
					display: 'none',
				},
				'& .MuiSvgIcon-root': { color: currentOfficeTheme.bodyForegroundColor },
				'& .MuiFormLabel-root': {
					color: COLORS.OUTLOOK_BLUE,
				},
				'& .MuiInput-input': {
					color: currentOfficeTheme.bodyForegroundColor,
					'& ::before': {
						color: 'red',
						borderColor: COLORS.OUTLOOK_BLUE,
					},
				},
				'& .MuiTextField-root': {
					color: currentOfficeTheme.bodyForegroundColor,
					borderColor: COLORS.OUTLOOK_BLUE,
					' & ::placeholder': {
						color: COLORS.BG_GREY_LIGHT,
					},
					'& ::before': {
						borderColor: COLORS.OUTLOOK_BLUE,
						'&:hover': {
							borderColor: COLORS.OUTLOOK_BLUE,
						},
					},
				},
			},
		},
	};
};

export const dataGridStyling = (
	FClr = CURRENT_OFFICE_THEME.controlForegroundColor,
	BClr = CURRENT_OFFICE_THEME.bodyBackgroundColor,
	primaryClr,
	currentOfficeTheme,
) => {
	return {
		background: isBGClrDark() ? BClr : COLORS.DATA_GRID_CELL_BACKGROUND,
		boxShadow: 2,
		borderWidth: '1px',
		borderColor:
			currentOfficeTheme.themeId === THEME_ID.BLACK
				? `0.8px solid ${currentOfficeTheme.bodyForegroundColor}`
				: '1px solid rgba(174, 180, 189, 1)',
		outlineColor: primaryClr,
		borderRadius: '2px',
		'& .MuiDataGrid-columnSeparator': { visibility: 'visible' },
		'& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator': {
			display: 'none!important',
		},
		'& .MuiDataGrid-row:hover': {
			backgroundColor:
				currentOfficeTheme?.themeId === THEME_ID.BLACK || currentOfficeTheme?.themeId === THEME_ID.DARK_GREY
					? '#383838'
					: '#e6f2fa',
		},
		'& .MuiBox-root:hover': {
			cursor: 'default',
			fontSize: '12px',
			fontFamily: baseFontFamilyStyle,
			'& .MuiButtonBase-root:hover': {
				backgroundColor: 'transparent',
				color: FClr,
			},
		},
		'& .MuiDataGrid-columnHeaders': {
			minHeight: '20px !important',
			background: BClr,
		},
		'& .MuiDataGrid-overlay': {
			height: '110%',
		},
		'& .MuiDataGrid-cell': {
			color: FClr,
			fontSize: '12px',
			fontFamily: baseFontFamilyStyle,
			border: 0,
			borderColor: 'transparent',
			':focus-within, :focus, :active': {
				backgroundColor: 'transparent',
				outline: 0,
			},
		},
		'& .super-app-theme--header': {
			color: primaryClr,
			height: '24px',
			minHeight: '28px',
			maxHeight: '28px',
			lineHeight: '28px',
			marginTop: '0px',
			fontFamily: baseFontFamilyStyle,
		},
		'& .MuiDataGrid-columnHeaderTitle': {
			fontWeight: 'Semibold',
			fontFamily: baseFontFamilyStyle,
			fontSize: '13px',
		},
		'& .MuiButton-textPrimary': {
			fontWeight: 'Regular',
			fontFamily: baseFontFamilyStyle,
			fontSize: '13px',
		},
		'& .MuiDataGrid-cellContent': {
			fontSize: '12px',
			fontFamily: baseFontFamilyStyle,
		},
		'& .MuiSelect-icon': {
			color: FClr,
		},
		'& .Mui-disabled': {
			color: FClr,
		},
		'& .MuiSvgIcon-root': {
			color:
				currentOfficeTheme.themeId === THEME_ID.BLACK
					? `0.8px solid ${currentOfficeTheme.bodyForegroundColor}`
					: '1px solid rgba(174, 180, 189, 1)',
		},
		'& .MuiDataGrid-footerContainer': {
			minHeight: '30px',
			height: '30px',
			paddingLeft: '8px',
			fontSize: '12px',
			fontFamily: baseFontFamilyStyle,
			background: BClr,
			color: FClr,
		},
		'& .MuiTablePagination-selectLabel': {
			fontSize: '12px',
			fontFamily: baseFontFamilyStyle,
			color: FClr,
		},
		'& .MuiInputBase-input': {
			fontSize: '12px',
			fontFamily: baseFontFamilyStyle,
			color: FClr,
		},
		'& .MuiTablePagination-displayedRows': {
			fontSize: '12px',
			fontFamily: baseFontFamilyStyle,
			color: FClr,
		},
		'& .MuiTablePagination-toolbar': {
			minHeight: '32px',
		},
	};
};

export const splitItemstyles = (
	FClr = CURRENT_OFFICE_THEME.bodyForegroundColor,
	BClr = CURRENT_OFFICE_THEME.bodyBackgroundColor,
) => ({
	root: {
		display: 'flex',
		alignItems: 'left',
		background: 'transparent',
		color: FClr,
		padding: '5px',
		cursor: 'pointer',
		overflow: 'scroll',
		border: 'ridge',
		margin: '3px',
	},
});

export const parentContainerStyle = {
	root: {
		height: '100%',
		width: '100%',
	},
};

export const stackStyles = {
	root: {
		background: 'transparent',
		alignContent: 'center',
	},
};

export const stackStyles2 = {
	root: {
		background: 'transparent',
		height: '28px',
		alignContent: 'center',
	},
};

export const stackItemStyles = (
	FClr = CURRENT_OFFICE_THEME.bodyForegroundColor,
	BClr = CURRENT_OFFICE_THEME.bodyBackgroundColor,
) => ({
	root: {
		display: 'flex',
		flexWrap: 'wrap',
		background: 'transparent',
		color: FClr,
		padding: '0px',
		align: 'end',
		alignContent: 'center',
	},
});

export const stackItemStyles2 = (
	FClr = CURRENT_OFFICE_THEME.bodyForegroundColor,
	BClr = CURRENT_OFFICE_THEME.bodyBackgroundColor,
) => ({
	root: {
		display: 'flex',
		flexWrap: 'wrap',
		background: 'transparent',
		color: FClr,
		padding: '0px',
		cursor: 'pointer',
		align: 'end',
		alignContent: 'center',
		marginLeft: '6px',
		marginRight: '6px',
	},
});

export const stackIconStyles = (
	FClr = CURRENT_OFFICE_THEME.bodyForegroundColor,
	BClr = CURRENT_OFFICE_THEME.bodyBackgroundColor,
) => ({
	root: {
		color: FClr,
		padding: '1em',
		cursor: 'pointer',
	},
});

export const subHeaderStyle = {
	fontSize: '14px',
};

export const textStyle = {
	fontSize: '14px',
};

export const listStyle = {
	width: '100%',
	maxWidth: 360,
	bgcolor: 'background.paper',
};

export const labelStyles = {
	fontSize: '12px',
	color: 'Grey',
	horizontalAlign: 'left',
};

export const settingIconStyle = currentOfficeTheme => ({
	height: '100%',
	marginLeft: '0.5rem',
	background: currentOfficeTheme.bodyBackgroundColor,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	border:
		currentOfficeTheme.themeId === THEME_ID.BLACK
			? `0.8px solid ${currentOfficeTheme.bodyForegroundColor}`
			: '1px solid rgba(174, 180, 189, 1)',
	cursor: 'pointer',
	minWidth: 35,
	maxHeight: 35,
});

export const customDropDownStyles = currentOfficeTheme => ({
	control: (provided, state) => ({
		...provided,
		minHeight: 'auto',
		minWidth: '250px',
		backgroundColor: currentOfficeTheme.bodyBackgroundColor,
		color: currentOfficeTheme.bodyForegroundColor,
		borderColor: currentOfficeTheme.bodyForegroundColor,
	}),
	valueContainer: (provided, state) => ({
		...provided,
		minHeight: 'auto',
		minWidth: 'auto',
		backgroundColor: currentOfficeTheme.bodyBackgroundColor,
		color: currentOfficeTheme.bodyForegroundColor,
	}),
	placeholder: (provided, state) => ({
		...provided,
		color: currentOfficeTheme.bodyForegroundColor,
		opacity: 0.9,
	}),
	menuList: base => ({
		...base,
		backgroundColor: currentOfficeTheme.bodyBackgroundColor,
		color: currentOfficeTheme.bodyForegroundColor,
	}),
	input: (provided, state) => ({
		...provided,
		color: currentOfficeTheme.bodyForegroundColor,
	}),

	indicatorSeparator: styles => ({
		...styles,
		background: currentOfficeTheme.bodyBackgroundColor,
	}),

	dropdownIndicator: styles => ({
		...styles,
		backgroundColor: currentOfficeTheme.bodyBackgroundColor,
		color: currentOfficeTheme.bodyForegroundColor,
	}),

	option: (base, { data, isDisabled, isFocused, isSelected }) => {
		return {
			...base,
			backgroundColor: data && currentOfficeTheme.bodyBackgroundColor,
			color: !isFocused ? data && currentOfficeTheme.bodyForegroundColor : COLORS.OUTLOOK_BLUE,
			opacity: isSelected ? 0.6 : 1,
		};
	},
	multiValue: base => ({
		...base,
		backgroundColor: currentOfficeTheme.bodyBackgroundColor,
	}),
	multiValueLabel: base => ({
		...base,
		color: currentOfficeTheme.bodyForegroundColor,
	}),

	singleValue: base => ({
		...base,
		color: currentOfficeTheme.bodyForegroundColor,
	}),
});

export const disabledCustomStylesDropbox = currentOfficeTheme => ({
	menuPortal: base => ({ ...base, zIndex: 9999 }),
	control: (provided, state) => ({
		...provided,
		minHeight: '10px',
		minWidth: '250px',
		marginBottom: '16px',
		border: state.isFocused ? 0 : 0,
		// This line disable the blue border
		boxShadow: state.isFocused ? 0 : 0,
		'&:hover': {
			border: state.isFocused ? 0 : 0,
		},
		backgroundColor: 'transparent',
		color: currentOfficeTheme.bodyForegroundColor,
	}),
	valueContainer: (provided, state) => ({
		...provided,
		minHeight: '10px',
		minWidth: 'auto',
		padding: '0 6px',
		backgroundColor: 'transparent',
		color: currentOfficeTheme.bodyForegroundColor,
	}),
	placeholder: (provided, state) => ({
		...provided,
		fontWeight: 'normal',
		color: currentOfficeTheme.bodyForegroundColor,
		fontFamily: baseFontFamilyStyle,
		fontWeight:
			currentOfficeTheme.themeId === THEME_ID.BLACK || currentOfficeTheme.themeId === THEME_ID.DARK_GREY
				? 100
				: 400,
		opacity:
			currentOfficeTheme.themeId === THEME_ID.BLACK || currentOfficeTheme.themeId === THEME_ID.DARK_GREY
				? 0.3
				: 0.9,
	}),
	menuList: base => ({
		...base,
		backgroundColor: 'transparent',
		color: currentOfficeTheme.bodyForegroundColor,
		zIndex: 9999,
		boxShadow:
			currentOfficeTheme.themeId === THEME_ID.BLACK || currentOfficeTheme.themeId === THEME_ID.DARK_GREY
				? `${COLORS.BG_GREY_DARK} 0px 0px 1px 0.1px, ${COLORS.BG_GREY_DARK} 0px 0px 1px 0.1px, ${COLORS.BG_GREY_DARK} 0px 0px 1px 0.1px, ${COLORS.BG_GREY_DARK} 0px 0px 5px 0.1px`
				: '',
	}),
	input: (provided, state) => ({
		...provided,
		margin: '0px', // Remove any margin from the input
		padding: '0px',
		color: currentOfficeTheme.bodyForegroundColor,
	}),

	indicatorSeparator: styles => ({
		...styles,
		background: currentOfficeTheme.bodyBackgroundColor,
	}),

	dropdownIndicator: styles => ({
		...styles,
		backgroundColor: currentOfficeTheme.bodyBackgroundColor,
		color: currentOfficeTheme.bodyBackgroundColor,
	}),

	option: (base, { data, isDisabled, isFocused, isSelected }) => {
		return {
			...base,
			backgroundColor: data && currentOfficeTheme.bodyBackgroundColor,
			color: !isFocused ? data && currentOfficeTheme.bodyForegroundColor : COLORS.OUTLOOK_BLUE,
			opacity: isSelected ? 0.6 : 1,
			zIndex: 9999,
		};
	},
	multiValue: base => ({
		...base,
		backgroundColor: currentOfficeTheme.bodyBackgroundColor,
	}),
	multiValueLabel: base => ({
		...base,
		color: currentOfficeTheme.bodyForegroundColor,
	}),

	singleValue: base => ({
		...base,
		color: currentOfficeTheme.bodyForegroundColor,
	}),
});

export const customStyles = currentOfficeTheme => ({
	menuPortal: base => ({ ...base, zIndex: 9999 }),
	control: (provided, state) => ({
		...provided,
		minHeight: '38px',
		width: 'auto',
		borderRadius: 0,
		borderColor: state.isFocused ? '#0000FF' : 'rgba(174, 180, 189, 1)',
		'&:hover': {
			borderColor: state.isFocused ? '#0000FF' : currentOfficeTheme.bodyForegroundColor,
		},
		backgroundColor: currentOfficeTheme.bodyBackgroundColor,
		color: currentOfficeTheme.bodyForegroundColor,
	}),
	valueContainer: (provided, state) => ({
		...provided,
		minHeight: 'auto',
		minWidth: 'auto',
		backgroundColor: currentOfficeTheme.bodyBackgroundColor,
		color: currentOfficeTheme.bodyForegroundColor,
	}),
	placeholder: (provided, state) => ({
		...provided,
		fontWeight: 'normal',
		color: currentOfficeTheme.bodyForegroundColor,
		fontFamily: baseFontFamilyStyle,
		fontWeight:
			currentOfficeTheme.themeId === THEME_ID.BLACK || currentOfficeTheme.themeId === THEME_ID.DARK_GREY
				? 100
				: 400,
		opacity:
			currentOfficeTheme.themeId === THEME_ID.BLACK || currentOfficeTheme.themeId === THEME_ID.DARK_GREY
				? 0.3
				: 0.9,
	}),
	menuList: base => ({
		...base,
		backgroundColor: currentOfficeTheme.bodyBackgroundColor,
		color: currentOfficeTheme.bodyForegroundColor,
		zIndex: 9999,
		boxShadow:
			currentOfficeTheme.themeId === THEME_ID.BLACK || currentOfficeTheme.themeId === THEME_ID.DARK_GREY
				? `${COLORS.BG_GREY_DARK} 0px 0px 1px 0.1px, ${COLORS.BG_GREY_DARK} 0px 0px 1px 0.1px, ${COLORS.BG_GREY_DARK} 0px 0px 1px 0.1px, ${COLORS.BG_GREY_DARK} 0px 0px 5px 0.1px`
				: '',
	}),
	input: (provided, state) => ({
		...provided,
		color: currentOfficeTheme.bodyForegroundColor,
	}),

	indicatorSeparator: styles => ({
		...styles,
		background: currentOfficeTheme.bodyBackgroundColor,
	}),

	dropdownIndicator: styles => ({
		...styles,
		padding: '0px',
		backgroundColor: currentOfficeTheme.bodyBackgroundColor,
		color: currentOfficeTheme.bodyForegroundColor,
	}),

	option: (base, { data, isDisabled, isFocused, isSelected }) => {
		return {
			...base,
			backgroundColor: data && currentOfficeTheme.bodyBackgroundColor,
			color: !isFocused ? data && currentOfficeTheme.bodyForegroundColor : COLORS.OUTLOOK_BLUE,
			opacity: isSelected ? 0.6 : 1,
			zIndex: 9999,
		};
	},
	multiValue: base => ({
		...base,
		backgroundColor: currentOfficeTheme.bodyBackgroundColor,
	}),
	multiValueLabel: base => ({
		...base,
		color: currentOfficeTheme.bodyForegroundColor,
	}),

	singleValue: base => ({
		...base,
		color: currentOfficeTheme.bodyForegroundColor,
	}),
});

export const invalidCustomStyles = currentOfficeTheme => ({
	menuPortal: base => ({ ...base, zIndex: 9999 }),
	control: (provided, state) => ({
		...provided,
		minHeight: '38px',
		minWidth: '250px',
		backgroundColor: currentOfficeTheme.bodyBackgroundColor,
		color: currentOfficeTheme.bodyForegroundColor,
		borderColor: 'rgb(164, 38, 44)',
		'&:hover': {
			borderColor: 'rgb(164, 38, 44)',
		},
	}),
	valueContainer: (provided, state) => ({
		...provided,
		minHeight: 'auto',
		minWidth: 'auto',
		backgroundColor: currentOfficeTheme.bodyBackgroundColor,
		color: currentOfficeTheme.bodyForegroundColor,
	}),
	placeholder: (provided, state) => ({
		...provided,
		fontWeight: 'normal',
		color: currentOfficeTheme.bodyForegroundColor,
		fontFamily: baseFontFamilyStyle,
		fontWeight:
			currentOfficeTheme.themeId === THEME_ID.BLACK || currentOfficeTheme.themeId === THEME_ID.DARK_GREY
				? 100
				: 400,
		opacity:
			currentOfficeTheme.themeId === THEME_ID.BLACK || currentOfficeTheme.themeId === THEME_ID.DARK_GREY
				? 0.3
				: 0.9,
	}),
	menuList: base => ({
		...base,
		backgroundColor: currentOfficeTheme.bodyBackgroundColor,
		color: currentOfficeTheme.bodyForegroundColor,
		zIndex: 9999,
	}),
	input: (provided, state) => ({
		...provided,
		color: currentOfficeTheme.bodyForegroundColor,
	}),

	dropdownIndicator: styles => ({
		...styles,
		backgroundColor: currentOfficeTheme.bodyBackgroundColor,
	}),

	indicatorSeparator: styles => ({
		...styles,
		background: currentOfficeTheme.bodyBackgroundColor,
	}),

	option: (base, { data, isDisabled, isFocused, isSelected }) => {
		return {
			...base,
			backgroundColor: data && currentOfficeTheme.bodyBackgroundColor,
			color: data && currentOfficeTheme.bodyForegroundColor,
			zIndex: 9999,
		};
	},
	multiValue: base => ({
		...base,
		backgroundColor: currentOfficeTheme.bodyBackgroundColor,
	}),
	multiValueLabel: base => ({
		...base,
		color: currentOfficeTheme.bodyForegroundColor,
	}),

	singleValue: base => ({
		...base,
		color: currentOfficeTheme.bodyForegroundColor,
	}),
});

export const StyledMenu = styled(props => (
	<Menu
		elevation={0}
		anchorOrigin={{
			vertical: 'bottom',
			horizontal: 'right',
		}}
		transformOrigin={{
			vertical: 'top',
			horizontal: 'right',
		}}
		{...props}
	/>
))(({ theme }) => ({
	'& .MuiPaper-root': {
		borderRadius: 6,
		marginTop: theme.spacing(1),
		minWidth: 180,
		color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
		boxShadow:
			'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
		'& .MuiMenu-list': {
			padding: '4px 0',
		},
		'& .MuiMenuItem-root': {
			'& .MuiSvgIcon-root': {
				fontSize: 18,
				color: theme.palette.text.secondary,
				marginRight: theme.spacing(1.5),
			},
			'&:active': {
				backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
			},
		},
	},
}));

export const searchInputStyles = currentOfficeTheme => {
	return {
		root: {
			width: '100%',
			minHeight: '38px',
			background: currentOfficeTheme.bodyBackgroundColor,
			color: currentOfficeTheme.bodyForegroundColor,
			border:
				currentOfficeTheme.themeId === THEME_ID.BLACK
					? `0.8px solid ${currentOfficeTheme.bodyForegroundColor}`
					: '1px solid rgba(174, 180, 189, 1)',
			':hover': {
				border: `0.5px solid ${isBGClrDark() ? COLORS.OUTLOOK_LIGHT_BLUE : COLORS.OUTLOOK_DARK_BLUE}`,
			},
		},
		field: {
			color: currentOfficeTheme.bodyForegroundColor,
			fontFamily: baseFontFamilyStyle,
			border: 'none',
			'::placeholder': {
				color: currentOfficeTheme.bodyForegroundColor,
				opacity: '0.5',
			},
		},
		icon: {
			color: isBGClrDark() ? COLORS.OUTLOOK_LIGHT_BLUE : COLORS.OUTLOOK_DARK_BLUE,
		},
		clearButton: {
			'& .ms-Button-icon': {
				color: currentOfficeTheme.bodyForegroundColor,
			},
			'& .ms-Button': {
				backgroundColor: currentOfficeTheme.bodyBackgroundColor,
				':hover': {
					backgroundColor: COLORS.ICON_BLUE_COLOR,
				},
			},
		},
	};
};

export const getOfficeThemeStyle = (propertyValue) => {
	const container = document.getElementById('container');
	const computedStyles = window.getComputedStyle(container);
	const style = computedStyles.getPropertyValue(propertyValue);
	return style;
};